/**
 * Sipariş kalemi dropdown'larında gösterilen varyant özeti.
 *
 * Kağıt rezervasyonu, koli girişi ve etiket girişi ekranlarının üçü de aynı
 * "Sipariş Kalemi" dropdown'ını kullanıyor; bu yüzden tek yerde tutuluyor.
 *
 * Birimler: GSM "gr", CAP "cm", PACKQUAN "li" eki. KIND/COLOR/TYPE birimsiz.
 * Değeri olmayan boyut atlanır (ör. baskısız üründe COLOR boş gelir).
 *
 * Alanlar backend'de listSalesOrderItems tarafından doldurulur.
 */
export function itemVariantSummary(item) {
  if (!item) return "";
  const parts = [];
  const push = (value, suffix = "") => {
    const v = String(value ?? "").trim();
    if (v) parts.push(`${v}${suffix}`);
  };

  push(item.gsm, " gr");
  push(item.kind);
  push(item.color);
  push(item.packquan, "'li");
  push(item.cap, " cm");
  push(item.type);

  return parts.join(" • ");
}

/** Miktarı tr-TR biçiminde gösterir; tam sayılarda ondalık basmaz. */
export function fmtItemQty(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "-";
  return n % 1 === 0
    ? n.toLocaleString("tr-TR")
    : n.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 4 });
}
